import { formatDate, formatTime } from "../localization/format.ts";
import { say } from "../localization/say.ts";

const MORNING = 9;

const AFTERNOON = 17;

const EVENING = 20;

const ROOM = 60 * 60 * 1000;

const MINUTE = 60 * 1000;
const MONDAY = 1;
const SATURDAY = 6;

export type SnoozeId =
  | "tenMinutes"
  | "anHour"
  | "laterToday"
  | "thisEvening"
  | "tomorrow"
  | "thisWeekend"
  | "nextWeek";

export type Offer = { id: SnoozeId; label: string; until: Date };

function at(now: Date, addDays: number, hour: number): Date {
  const when = new Date(now);
  when.setDate(when.getDate() + addDays);
  when.setHours(hour, 0, 0, 0);
  return when;
}

function daysTo(now: Date, weekday: number): number {
  return ((weekday - now.getDay() + 7 - 1) % 7) + 1;
}

export function snoozeOffers(now: Date = new Date()): Offer[] {
  const day = now.getDay();
  const offers: Offer[] = [
    { id: "tenMinutes", label: say("snooze.tenMinutes"), until: new Date(now.getTime() + 10 * MINUTE) },
    { id: "anHour", label: say("snooze.anHour"), until: new Date(now.getTime() + 60 * MINUTE) },
  ];

  const afternoon = at(now, 0, AFTERNOON);
  if (afternoon.getTime() - now.getTime() >= ROOM)
    offers.push({ id: "laterToday", label: say("snooze.laterToday"), until: afternoon });

  const evening = at(now, 0, EVENING);
  if (now.getTime() < evening.getTime())
    offers.push({ id: "thisEvening", label: say("snooze.thisEvening"), until: evening });

  offers.push({ id: "tomorrow", label: say("snooze.tomorrow"), until: at(now, 1, MORNING) });

  if (day !== SATURDAY && day !== 0)
    offers.push({
      id: "thisWeekend",
      label: say("snooze.thisWeekend"),
      until: at(now, daysTo(now, SATURDAY), MORNING),
    });

  const monday = at(now, daysTo(now, MONDAY), MORNING);
  if (monday.getTime() !== at(now, 1, MORNING).getTime())
    offers.push({ id: "nextWeek", label: say("snooze.nextWeek"), until: monday });

  return offers;
}

export function whenItMeans(until: Date, now: Date = new Date()): string {
  const clock = formatTime(until);
  const sameDay = until.toDateString() === now.toDateString();
  if (sameDay) return clock;
  const weekday = formatDate(until, { weekday: "short" });
  return say("snooze.dayAndTime")(weekday, clock);
}
